"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    getMeasurement,
    borderRadiusProps
  } = (0, _hooks.useStylesUtils)();
  const {
    type = 'basic',
    boxShadowColor = themeColors?.basic.shadow,
    background = type === 'graphic' ? themeColors?.basic.main : themeColors?.general.light,
    textColor = themeColors?.general.text,
    width = 'fit-content',
    height = 'auto',
    isWithShadow = true,
    borderRadius = {}
  } = props;
  const ccCardStyle = (0, _react.useMemo)(() => {
    const deviceTypeProps = () => {
      let borderRadius;
      let boxShadow;
      if (isMobileView && type === 'graphic') {
        borderRadius = pxToRem(26);
        boxShadow = 'none';
      } else {
        if (type === 'graphic') {
          borderRadius = pxToRem(53);
          boxShadow = `${pxToRem(0)} ${pxToRem(3)} ${pxToRem(6)} ${boxShadowColor}`;
        } else {
          borderRadius = pxToRem(10);
          boxShadow = `0 0 ${pxToRem(7)} ${boxShadowColor}`;
        }
      }
      if (!isWithShadow) {
        boxShadow = 'none';
      }
      return {
        borderRadius,
        boxShadow
      };
    };
    const ccCard = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      boxSizing: 'border-box',
      fontFamily: fontFamily,
      background: background,
      color: textColor,
      width: getMeasurement(width),
      height: getMeasurement(height),
      ...deviceTypeProps(),
      ...borderRadiusProps(borderRadius)
    });
    return ccCard;
  }, [background, borderRadius, borderRadiusProps, boxShadowColor, fontFamily, getMeasurement, height, isMobileView, isWithShadow, pxToRem, textColor, type, width]);
  return {
    'cc-Card': ccCardStyle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;